import React, { useCallback } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
} from '@material-ui/core';

export const ConfirmedActionModal = ({
  text,
  confirmButtonText,
  open,
  onClose,
  onConfirm,
}) => {
  const confirm = useCallback(() => {
    onConfirm();
    onClose();
  }, [onConfirm, onClose]);
  return (
    <Dialog
      open={open}
      maxWidth='xs'
      fullWidth
      onClose={reason => {
        if (reason !== 'backdropClick') {
          onClose();
        }
      }}
    >
      <DialogContent>
        <Typography variant='body1' style={{ margin: '30px 0' }}>
          {text}
        </Typography>
        <DialogActions>
          <Button
            variant='contained'
            color='secondary'
            size='small'
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            variant='contained'
            color='primary'
            size='small'
            onClick={confirm}
          >
            {confirmButtonText}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};
